
import { xml2json } from 'xml-js';
import { baseAxiosCall } from 'src/services/axiosHelper';


const baseURL = 'https://www.merckmanuals.com';


export async function searchMerck(code: string): Promise<MerckResult> {
  const data = await baseAxiosCall<string>({
    method: 'get',
    baseURL,
    url: '/professional/infobutton/search',
    params: {
      'taskContext.c.c': 'PROBLISTREV',
      'holder.assignedEntity.n': 'TruCode',
      'holder.assignedEntity.certificateText': 'Winter19',
      informationRecipient: 'PROV',
      knowledgeResponseType: 'application/json',
      'mainSearchCriteria.v.c': code,
      'mainSearchCriteria.v.cs': '2.16.840.1.113883.6.90'
    }
  });

  // eslint-disable-next-line
  const json: any = JSON.parse(xml2json(data, {compact: true }));
  return {
    title: json?.feed?.entry?.title?._text,
    link: json?.feed?.entry?.link?._attributes?.href
  }
}

export interface MerckResult {
  title?: string,
  link?: string
}